
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Button, Listbox, ListboxButton, ListboxOption, ListboxOptions, Switch } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import CodeMirror from 'codemirror';
import 'codemirror/addon/mode/overlay.js';
import "codemirror/lib/codemirror.css";
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import "codemirror/theme/material.css";
import { Resizable } from 're-resizable';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Controlled as Editor } from 'react-codemirror2';
import SimpleBar from 'simplebar-react';
import './App.css';
import { WidgetComponent } from './components/widget/widget.component';
import { EmfWidgetConfig, EmfWidgetThemeType, EmfWidgetType } from './components/widget/widget.models';
import { WidgetService } from './components/widget/widget.service';
import AdministrationComponent from './Administration';
import { WidgetConfigurationPanelDataModel, WidgetDbDemoModel } from './App.model';
import { defaultPrimaryColor } from './utils'


let username = 'Aditya Kumar Singh';
let userId = 'COFORGE\\aditya.3.singh';
let target = 'uwr_premo';
let widgetsToShow = []; // TO Show all widgets
let widgetsToShow1 = [ // TO show specific widget(s)
  // EmfWidgetType.business_flow,
  // EmfWidgetType.quote_metrics,
  // EmfWidgetType.submission_metrics,
  // EmfWidgetType.jtbd_metrics,
  //EmfWidgetType.broker_quote_count_trend_v2
] as string[]

const targets = [
  { id: 'uwr_preqc', name: 'Underwriting PRE QC' },
  { id: 'uwr_qc', name: 'Underwriting QC' },
  { id: 'mo_demo', name: 'Underwriting MO' },
  { id: 'uwr_premo', name: 'Underwriting PRE MO' },
  { id: 'uwr_intdev', name: 'Underwriting Int DEV' },
  { id: 'mutistrat_qc', name: 'Mutistrat QC' },
  { id: 'multistrat_qc', name: 'Multistrat QC' }
];


const ToggleThemeSwitch = ({ primaryColorCode, property, selectedVal, onChange }) => {
  const [enabled, setEnabled] = useState(selectedVal);

  const handleSwitchChange = (value: boolean) => {
    setEnabled(value);
    onChange(value);
  };

  return (
    <div className="emf-flex emf-flex-col ">
      <label className="emf-w-full emf-text-sm emf-capitalize">
        Set Light or Dark Theme
      </label>
      <div style={{ border: '1px solid #d1d5db' }} className="emf-flex emf-space-x-2 emf-items-center emf-p-1 emf-px-4 emf-text-left emf-rounded ">
        <Switch
          id={property}
          checked={enabled}
          onChange={handleSwitchChange}
          style={{ backgroundColor: enabled ? primaryColorCode : '' }}
          className={`emf-relative emf-p-0 emf-inline-flex emf-h-5 emf-w-10 emf-shrink-0 emf-cursor-pointer emf-rounded-full emf-border-2 emf-border-transparent emf-transition-colors emf-duration-200 emf-ease-in-out ${enabled ? '' : 'emf-bg-gray-300'}`}>
          <span className={`emf-inline-block emf-h-4 emf-w-4 emf-transform emf-rounded-full emf-bg-white emf-shadow emf-ring-0 emf-transition emf-duration-200 emf-ease-in-out ${enabled ? 'emf-translate-x-5' : 'emf-translate-x-0'}`} />
        </Switch>
        <label htmlFor={property} className="emf-text-gray-700 emf-font-medium emf-cursor-pointer">
          {enabled ? 'Dark' : 'Light'}
        </label>
      </div>
    </div>

  );
};


const TargetSelectionDropdown = ({ selectedVal, onSelectionChange }) => {



  let selectedOne = targets.find(t => t.id == selectedVal);
  if (!selectedOne) { selectedOne = targets[0]; }

  const [selected, setSelected] = useState(selectedOne);

  useEffect(() => {
    onSelectionChange(selected.id);
  }, [selected]);

  return (
    <div className="emf-relative emf-w-full emf-overflow-visible">
      <label className="emf-w-full emf-text-sm emf-capitalize">
        Target
      </label>
      <Listbox value={selected} onChange={setSelected}>
        <ListboxButton style={{ border: '1px solid #d1d5db' }} className="emf-relative emf-w-full emf-cursor-pointer emf-rounded emf-bg-white emf-p-2 emf-px-4 emf-text-left focus:emf-outline-none emf-text-gray-700 emf-font-medium">
          {selected.name}
          <ChevronDownIcon className="emf-group emf-pointer-events-none emf-absolute emf-top-2.5 emf-right-2.5 emf-size-4 emf-fill-white/60" aria-hidden="true" />
        </ListboxButton>
        <ListboxOptions className="emf-absolute emf-mt-1 emf-z-10 emf-max-h-60 emf-w-full emf-overflow-auto emf-rounded-md emf-bg-white emf-py-1 emf-text-base emf-shadow emf-ring-1 emf-ring-black emf-ring-opacity-5 focus:emf-outline-none">
          {targets.map((option) => (
            <ListboxOption
              key={option.id}
              value={option}
              className={({ active }) => `emf-relative emf-cursor-pointer emf-select-none emf-p-2 emf-px-4 ${active ? 'emf-bg-blue-100 emf-text-blue-900' : 'emf-text-gray-900'}`}>
              {({ selected }) => (
                <span className={`emf-block emf-text-gray-700 emf-font-medium emf-truncate ${selected ? 'emf-font-medium' : 'emf-font-normal'}`}>
                  {option.name}
                </span>
              )}
            </ListboxOption>
          ))}
        </ListboxOptions>
      </Listbox>
    </div>
  );
};


const MappingParameterTextbox = ({ paramName, value, required, onChange }) => {
  const [val, setVal] = useState(value);
  const handleChange = (value: string) => {
    setVal(value);
    onChange(paramName, value);
  };
  return (
    <div className="emf-flex emf-flex-col">
      <label className="emf-max-w-full emf-truncate emf-text-ellipsis emf-text-sm emf-capitalize emf-relative">
        <div className="emf-text-sm"> {paramName} {required ? <span className='emf-ml-1 emf-p-0 emf-mb-2 emf-text-lg emf-text-red-400'>*</span> : ''}</div>
      </label>
      <input title={val} style={{ border: '1px solid #d1d5db' }} type='text' onChange={(e) => handleChange(e.target.value)} value={val} className="emf-p-2 emf-px-4 emf-text-left emf-rounded focus:emf-outline-none emf-text-gray-700 emf-font-medium">
      </input>
    </div>
  );
};


const WidgetParamConfigurationPanel = (data: WidgetConfigurationPanelDataModel) => {

  if (!data?.currentWidget) return <></>;

  const [currentWidget, setCurrentWidget] = useState(data.currentWidget);
  const [previewLoading, setPreviewLoading] = useState(false);


  const onParamValueChange = (property: string, value: string) => {
    if (!currentWidget) return;
    let p = currentWidget.params.find(p => p.name?.toLowerCase() == property.toLowerCase());
    if (!p) {
      p = { name: property.toLowerCase(), value: value, mandatory: false, readonly: false, desc: '', mapping: '' };
      currentWidget.params = currentWidget.params.filter(p => p.name !== property.toLowerCase())
      currentWidget.params.push(p)
    }
    if (p) {
      p.value = value;
      setCurrentWidget(currentWidget);
    }
  }

  const onThemeAttrChange = (dark: boolean) => {
    if (!currentWidget) return;
    let p = currentWidget.params.find(p => p.name?.toLowerCase() == 'theme');
    if (!p) {
      p = { name: 'theme', value: '', mandatory: false, readonly: false, desc: '', mapping: '' };
      currentWidget.params.push(p)
    }
    if (p) {
      p.value = dark ? 'dark' : 'light';
      setCurrentWidget(currentWidget);
    }
  }

  const getMappingParams = () => {
    if (!currentWidget) return [];
    const mappingParams = currentWidget.params.filter(f => (f.name != 'type' && f.name != 'target' && f.name != 'title' && f.name != 'primaryColor' && f.name != 'theme' && f.name != 'timestamp'));
    return mappingParams;
  }

  const getRequiredValueByProperty = (property: string, widget: WidgetDbDemoModel): string => {
    if (!widget) return undefined;
    let param = widget.params.find(p => p.name == property);
    return param?.value;
  }

  const onApply = () => {
    if (!currentWidget || currentWidget.type == 'all') return;
    if (!currentWidget || currentWidget.type == 'administration') return;
    setPreviewLoading(true);
    setTimeout(() => {
      setPreviewLoading(false);
    }, 2000);
    data.onApplyClick && data.onApplyClick(currentWidget);
  }

  const target = getRequiredValueByProperty('target', currentWidget) || targets[0].id;
  const primaryColor = getRequiredValueByProperty('primaryColor', currentWidget) || defaultPrimaryColor;
  const theme = getRequiredValueByProperty('theme', currentWidget) as EmfWidgetThemeType;

  return (
    <div className="emf-bg-white emf-h-full emf-w-full emf-rounded-lg emf-p-5 emf-pt-3 emf-box-border">
      <div className="emf-grid emf-grid-cols-4 emf-items-end emf-place-content-between emf-gap-x-5 emf-gap-y-2 emf-flex-wrap">

        <div className="emf-w-full">
          <TargetSelectionDropdown selectedVal={target} onSelectionChange={(val) => onParamValueChange('target', val)}></TargetSelectionDropdown>
        </div>

        {
          getMappingParams().map(pItem => {
            return <div className="emf-w-full">
              <MappingParameterTextbox required={pItem.mandatory} value={pItem.value} paramName={pItem.name} onChange={onParamValueChange}></MappingParameterTextbox>
            </div>
          })
        }


        <div className="emf-w-full">
          <ToggleThemeSwitch primaryColorCode={primaryColor} selectedVal={theme == 'dark'} property={'Dark Theme'} onChange={(r: boolean) => onThemeAttrChange(r)}></ToggleThemeSwitch>
        </div>

        <div className="emf-w-full">
          <div className="emf-flex emf-items-center emf-content-end">
            <button style={{ backgroundColor: primaryColor, color: 'white', border: 0 }} onClick={onApply} type="button" className={`emf-cursor-pointer emf-py-2 emf-px-5 emf-text-sm emf-font-medium emf-rounded emf-opacity-80 hover:emf-opacity-100 emf-inline-flex emf-items-center`}>
              PREVIEW
              {
                !previewLoading && <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill={'white'} className="emf-inline emf-w-4 emf-h-4 emf-ml-1 emf-mr-1 emf-text-gray-200 dark:emf-text-gray-600" viewBox="0 0 16 16">
                  <path d="M6 12.796V3.204L11.481 8zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753" />
                </svg>
              }
              {
                previewLoading && <svg aria-hidden="true" role="status" className="emf-inline emf-w-4 emf-h-4 emf-ml-2 emf-text-gray-200 emf-animate-spin dark:emf-text-gray-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill={primaryColor} />
                </svg>
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}


const App = (props: any) => {

  const { instance } = useMsal();

  const handleRedirect = () => {
    instance.loginRedirect({ scopes: [] })
      .catch((error) => console.log(error));
  };

  const demoAccessKey = process.env.REACT_APP_DEMO_ACCESS_KEY;
  const resizableRef = useRef();
  const [html, setHtml] = useState('')
  const [srcDoc, setSrcDoc] = useState('')
  const [theme, setTheme] = useState<EmfWidgetThemeType>('light');
  const [activeView, setActiveView] = useState('library');
  const [widgets, setWidgets] = useState<WidgetDbDemoModel[]>([]);
  const [currentWidget, setCurrentWidget] = useState<WidgetDbDemoModel>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredWidgets, setFilteredWidgets] = useState<WidgetDbDemoModel[]>([]);
  const widgetService = useMemo(() => WidgetService.getInstance(), []);

  const handleSearchParam = (view: string, widget: string) => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('view', view);
    currentUrl.searchParams.set('widget', widget);
    if (!widget) {
      currentUrl.searchParams.delete('widget');
    }
    window.history.pushState({}, '', currentUrl.toString());
  };



  const onApply = (currentWidget: WidgetDbDemoModel) => {
    if (!currentWidget || currentWidget.type == 'all') return;
    if (!currentWidget || currentWidget.type == 'administration') return;
    updateWidgetStateVariables(currentWidget);
    let html = currentWidget.getHtml();
    setHtml(html);
    if (resizableRef.current) {
      const ref = resizableRef.current;
      handleResize(null, 'init', ref, { width: 0, height: 0 });
    }
  }



  const updateWidgetStateVariables = (widgetItem: WidgetDbDemoModel) => {
    if (!widgetItem || !widgetItem.params) { return }
    // This is to just reload the preview on every time preview button clicked!
    let u = widgetItem.params.find(p => p.name == 'timestamp');
    if (u) {
      u.value = new Date().getTime().toString();
    } else {
      widgetItem.params.push({ name: 'timestamp', desc: '', mandatory: false, readonly: true, value: new Date().getTime().toString(), mapping: "" })
    }
  }


  const [dimension, setDimension] = useState({ height: 0, width: 0 });
  const handleResize = (e, direction, ref, d) => {
    let logData = { width: ref.offsetWidth || ref.size.width, height: ref.offsetHeight || ref.size.height };
    setDimension(logData)
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const activeView = queryParams.get('view') || 'library';
    const widget = queryParams.get('widget') || '';
    setActiveView(activeView)
    const config = new EmfWidgetConfig();
    config.accessKey = demoAccessKey;

    widgetService.verifyWidgetKey(config).then(result => {
      if (result) {
        widgetService.getWidgets(config).then(res => {
          let list: WidgetDbDemoModel[] = [];
          if (res.data) {


            //#region Enable Disable Widgets           
            if (widgetsToShow.length) {
              res.data = res.data.filter(f => widgetsToShow.includes(f.type));
            }
            //#endregion
            res.data.forEach(d => list.push(new WidgetDbDemoModel(d)));
            let sortedList = list.sort((a, b) => (a.name < b.name ? -1 : 1));
            sortedList.forEach(w => {
              const useridObj = w.params.find(p => p.name == 'userid');
              if (useridObj) {
                useridObj.value = userId;
              }
              const usernameObj = w.params.find(p => p.name == 'username');
              if (usernameObj) {
                usernameObj.value = username;
              }
              const targetObj = w.params.find(p => p.name == 'target');
              if (targetObj) {
                targetObj.value = target;
              }
            })
            setWidgets(sortedList);
            setFilteredWidgets(sortedList);
            if (widget) {
              let activeWidget = sortedList.find(f => f.id == widget);
              if (activeWidget) {
                setCurrentWidget(activeWidget);
              }
            }
          }
        })
      }
    })

  }, [])

  useEffect(() => {
    if (!currentWidget || currentWidget.type == 'all') return;
    if (!currentWidget || currentWidget.type == 'administration') return;
    updateWidgetStateVariables(currentWidget);
    let html = currentWidget.getHtml();
    setHtml(html);
    if (resizableRef.current) {
      const ref = resizableRef.current;
      handleResize(null, 'init', ref, { width: 0, height: 0 });
    }
  }, [currentWidget])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSrcDoc(`
        <html style="height:100%; width:100%;">
          <body style="height:100%; width:100%; overflow:hidden; margin:0; padding:0">${html}</body>
          <script src="${widgetService.widgetHostUrl}/index.js?apikey=${widgetService.apiKey}"></script>
        </html>
    `)
    }, 250)
    return () => clearTimeout(timeout)
  }, [html])

  const handleActiveView = (e: React.MouseEvent<HTMLLIElement>, widgetItem: WidgetDbDemoModel) => {
    setCurrentWidget(widgetItem);
    if (widgetItem) {
      if (widgetItem.type == 'all') {
        setActiveView('library')
        handleSearchParam('library', null)
      } else if (widgetItem.type == 'administration') {
        setActiveView('administration')
        handleSearchParam('administration', null)
      } else {
        setActiveView('editor')
        let html = widgetItem.getHtml();
        setHtml(html);
        handleSearchParam('editor', widgetItem.id);
        updateWidgetStateVariables(widgetItem);
      }
    }
    let liItems = document.getElementById('menu-list').getElementsByTagName('li');
    if (liItems.length) {
      for (let item of liItems) {
        item.classList?.remove('active');
      }
    }
    e.currentTarget.classList.add('active');
  }

  const handleMenuSearchChange = (event) => {
    const newSearchTerm = event.target.value as string;
    setSearchTerm(newSearchTerm);
    let updatedFilteredItems = widgets;
    if (newSearchTerm && newSearchTerm.trim()) {
      updatedFilteredItems = widgets.filter(item =>
        item.name.toLowerCase().includes(newSearchTerm.toLowerCase())
      );
    }
    setFilteredWidgets(updatedFilteredItems);
  };

  const toggleTheme = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    let currentTheme = theme == 'light' ? 'dark' : 'light' as EmfWidgetThemeType;
    setTheme(currentTheme)
    widgets.forEach(w => {
      let t = w.params.find(p => p.name == 'theme');
      if (t) {
        t.value = currentTheme;
      }
    });
    setWidgets(widgets);
  }

  CodeMirror.defineMode('custom-html', (config: any) => {
    const htmlMode = CodeMirror.getMode(config, 'htmlmixed');

    const overlay = {
      token: function (stream: any) {
        const pattern = /\b(id|title|theme|settings|filter|refresh|header|primaryColor|target|username|userid|jobid|url|rsk_reference|reportid|iframePath)\b/;
        if (stream.match(pattern)) {
          return 'emf-code-mirror-highlight-word';
        }
        while (stream.next() != null && !stream.match(pattern, false)) { }
        return null;
      }
    };

    return CodeMirror.overlayMode(htmlMode, overlay);
  });


  useEffect(() => {
    if (resizableRef.current) {
      const ref = resizableRef.current;
      handleResize(null, 'init', ref, { width: 0, height: 0 });
    }
  }, []);


  return (
    <>
      <AuthenticatedTemplate>
        <div className='emf-w-full emf-h-full emf-overflow-hidden'>
          <aside className="aside is-placed-left is-expanded">
            <div className="emf-w-full">
              <div className="aside-tools">
                EMF Documentation
              </div>
              <input
                style={{ width: 'calc(100% - 18px)' }}
                value={searchTerm}
                onChange={handleMenuSearchChange}
                placeholder='Search widgets...' className='emf-h-8 emf-px-2 emf-pb-1 emf-bg-gray-700 emf-text-gray-300 focus:emf-outline-none emf-border-none'></input>
            </div>
            <div className="menu is-menu-main">
              <ul id="menu-list" className="menu-list">
                <SimpleBar style={{ height: 'calc(100vh - 72px)' }}>
                  <li className={activeView == 'library' ? 'active' : ''} onClick={(e) => handleActiveView(e, { type: 'all' } as WidgetDbDemoModel)}>
                    <a className="emf-flex emf-item-center emf-p-2 emf-text-sm emf-border-l-4 emf-text-gray-400 hover:emf-bg-gray-700 hover:emf-text-white emf-cursor-pointer emf-capitalize">
                      <span className="emf-flex emf-item-center emf-mr-2">
                        <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" className="emf-w-4">
                          <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                        </svg>
                      </span>
                      <span>All</span>
                    </a>
                  </li>

                  {filteredWidgets.map((item, i) => {
                    return (
                      <li className={currentWidget?.id == item.id ? 'active' : ''} key={i} onClick={(e) => handleActiveView(e, item)}>
                        <a className="emf-flex emf-item-center emf-p-2 emf-text-sm emf-border-l-4 emf-text-gray-400 hover:emf-bg-gray-700 hover:emf-text-white emf-cursor-pointer emf-capitalize">
                          <span className="emf-flex emf-item-center emf-mr-2">
                            <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" className="emf-w-4">
                              <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                            </svg>
                          </span>
                          <span className='emf-text-sm'>{item.name}</span>
                        </a>
                      </li>
                    )
                  })}


                  <li className={activeView == 'administration' ? 'active' : ''} onClick={(e) => handleActiveView(e, { type: 'administration' } as WidgetDbDemoModel)}>
                    <a className="emf-flex emf-item-center emf-p-2 emf-text-sm emf-border-l-4 emf-text-gray-400 hover:emf-bg-gray-700 hover:emf-text-white emf-cursor-pointer emf-capitalize">
                      <span className="emf-flex emf-item-center emf-mr-2">
                        <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" className="emf-w-4">
                          <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                        </svg>
                      </span>
                      <span>Administration</span>
                    </a>
                  </li>
                </SimpleBar>
              </ul>
            </div>
          </aside>
          {
            activeView != 'administration' && <> <nav id="navbar-main" className="navbar">
              <div className="navbar-brand">
                <a className="navbar-item mobile-aside-button">
                  <span className="icon"><i className="mdi mdi-forwardburger mdi-24px"></i></span>
                </a>
                <div className="navbar-item">
                  <div className="control">
                    <b>{currentWidget?.type == 'all' ? 'All Widgets' : ''}</b>
                    <b>{currentWidget?.type == 'administration' ? 'Administration' : ''}</b>
                    <b>{(currentWidget?.type !== 'all' && currentWidget?.type !== 'administration') ? currentWidget?.name : ''}</b>
                  </div>
                </div>
              </div>
              <div className="navbar-menu" id="navbar-menu">
                <div className="navbar-end">
                  <div className="navbar-item dropdown has-divider">
                    {
                      (activeView == 'library') && <button onClick={(e) => { toggleTheme(e); }} type="button" className="emf-text-gray-500 emf-border-none emf-cursor-pointer emf-inline-flex emf-items-center emf-justify-center hover:emf-bg-gray-100 emf-w-10 emf-h-10 emf-rounded-lg emf-text-sm emf-p-2.5">
                        {
                          theme == 'dark' && <svg id="theme-toggle-light-icon" className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M10 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-11a1 1 0 0 0 1-1V1a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1Zm0 12a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1ZM4.343 5.757a1 1 0 0 0 1.414-1.414L4.343 2.929a1 1 0 0 0-1.414 1.414l1.414 1.414Zm11.314 8.486a1 1 0 0 0-1.414 1.414l1.414 1.414a1 1 0 0 0 1.414-1.414l-1.414-1.414ZM4 10a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1Zm15-1h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2ZM4.343 14.243l-1.414 1.414a1 1 0 1 0 1.414 1.414l1.414-1.414a1 1 0 0 0-1.414-1.414ZM14.95 6.05a1 1 0 0 0 .707-.293l1.414-1.414a1 1 0 1 0-1.414-1.414l-1.414 1.414a1 1 0 0 0 .707 1.707Z"></path>
                          </svg>
                        }
                        {
                          theme == 'light' && <svg className="emf-w-4 emf-h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 20">
                            <path d="M17.8 13.75a1 1 0 0 0-.859-.5A7.488 7.488 0 0 1 10.52 2a1 1 0 0 0 0-.969A1.035 1.035 0 0 0 9.687.5h-.113a9.5 9.5 0 1 0 8.222 14.247 1 1 0 0 0 .004-.997Z"></path>
                          </svg>
                        }
                      </button>
                    }
                  </div>
                </div>
              </div>
            </nav>
              <div className="emf-bg-gray-100 emf-w-full emf-h-full emf-flex emf-flex-col emf-flex-1">

                {
                  activeView == 'library' &&
                  <div className="all-widgets emf-p-5">
                    <div className="emf-grid emf-grid-cols-3 emf-gap-5">
                      {
                        widgets.map((item, i) => {
                          return (
                            <div className={`emf-w-full emf-rounded-lg ${theme == 'dark' ? 'emf-bg-gray-600' : 'emf-bg-white'}${(item.type == EmfWidgetType.knowledgegraphdot || item.type == EmfWidgetType.widgetgroup) ? 'emf-row-span-2' : 'emf-row-span-1'}`}>
                              <WidgetComponent key={i} config={{ theme: theme, accessKey: demoAccessKey, attr: item.getAttr(), target: target, type: item.type }} />
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                }

                {

                  activeView == 'editor' &&
                  <div className="emf-m-5 emf-flex-1 emf-flex emf-flex-col editor-view">
                    <div className="emf-flex">
                      <div className="sidebar !emf-h-[calc(100vh-96px)] emf-w-1/4 emf-flex-col">
                        <div className="emf-flex-1 emf-h-full emf-overflow-auto emf-pr-5">
                          <div className="entry emf-h-full emf-cursor-pointer emf-rounded emf-flex emf-shadow-md">
                            <div className={`editor-container`}>
                              <div className="editor-title">
                                <div className="emf-flex emf-items-center">
                                  <svg className='emf-w-4 emf-h-5' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="html"><path fill="#E44D26" d="M3.345 21.601 1.419 0h21.162l-1.928 21.597L11.987 24l-8.642-2.399z"></path><path fill="#F16529" d="m12 22.164 7.003-1.941L20.65 1.766H12v20.398z"></path><path fill="#EBEBEB" d="M12 9.778H8.494l-.242-2.713H12V4.416H5.357l.063.71.651 7.301H12V9.778zm0 6.88-.012.003-2.95-.797-.189-2.113H6.19l.371 4.16 5.427 1.506.012-.003v-2.756z"></path><path fill="#FFF" d="M11.991 9.778v2.649h3.262l-.308 3.436-2.955.797v2.756l5.431-1.505.04-.448.623-6.975.065-.711h-.714l-5.444.001zm0-5.362v2.649h6.399l.053-.596.121-1.343.063-.711-6.636.001z"></path></svg>
                                  <span className="emf-ml-1">HTML</span>
                                </div>
                              </div>
                              <Editor
                                value={html}
                                className="code-mirror-wrapper"
                                options={{
                                  lineWrapping: true,
                                  lint: true,
                                  mode: 'custom-html',
                                  theme: 'material',
                                  lineNumbers: true,
                                  fontSize: 14
                                }}
                                onBeforeChange={(editor, data, value) => {
                                  setHtml(value)
                                }}
                                onChange={(editor, data, value) => { }}
                              />

                              <div className='emf-mt-2 script-editor-view'>
                                <div className="editor-title">
                                  <div className="emf-flex emf-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className='emf-w-4 emf-h-5' viewBox="0 0 16 16">
                                      <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0m6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0" /></svg>
                                    <span className="emf-ml-1">SCRIPT</span>
                                  </div>
                                </div>
                                <Editor
                                  value={`<script src="${widgetService.widgetHostUrl}index.js?apikey=${widgetService.apiKey}"></script>`}
                                  className="code-mirror-wrapper"
                                  options={{
                                    lineWrapping: true,
                                    lint: true,
                                    mode: 'xml',
                                    theme: 'material',
                                    lineNumbers: false,
                                    fontSize: 10,
                                  }}
                                  onBeforeChange={(editor, data, value) => { }}
                                />
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="!emf-h-[calc(100vh-96px)] emf-overflow-hidden emf-flex-1 emf-flex emf-gap-5 emf-flex-col">

                        <div className="emf-flex-grow-0">
                          <WidgetParamConfigurationPanel key={currentWidget?.id} currentWidget={currentWidget} onApplyClick={onApply}></WidgetParamConfigurationPanel>
                        </div>
                        <div className="emf-grow">
                          <Resizable
                            ref={resizableRef}
                            minWidth={320} minHeight={180}
                            onResize={handleResize}
                            maxWidth="100%"
                            maxHeight="100%"
                            defaultSize={{ height: "100%", width: "100%" }}
                            className='emf-bg-white emf-h-full emf-rounded-lg emf-resize emf-border-2 emf-border-gray-300 emf-border-dashed !emf-cursor-default'>
                            <div className='emf-absolute emf-right-0 -emf-top-5 emf-z-10 emf-text-xs'>
                              <span className='emf-mr-4'>Height: <span className='emf-text-red-500 emf-font-semibold'>{dimension.height}px</span> </span>
                              <span>Width: <span className='emf-text-red-500 emf-font-semibold'>{dimension.width}px</span> </span>
                            </div>
                            <iframe
                              className='emf-overflow-x-hidden'
                              srcDoc={srcDoc}
                              title="output"
                              sandbox="allow-scripts allow-popups"
                              frameBorder="0"
                              width="100%"
                              height="100%"
                            />
                          </Resizable>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </>
          }

          {
            activeView == 'administration' && <AdministrationComponent key="admin" />
          }
        </div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Button className="emf-bg-yellow-700 emf-border-none emf-h-12 emf-w-64 emf-cursor-pointer emf-rounded hover:emf-bg-yellow-600 emf-bg-opacity-75 emf-text-white emf-text-base" onClick={handleRedirect}>
          Please Sign In to continue
        </Button>
      </UnauthenticatedTemplate>
    </>
  )
}

export default App;


